import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MarkSuccessOnClick } from '@justgiving/experiments';
import { Button } from '@justgiving/react-tracking';

import { MessageOverrides, usePageOwner, useShareUrls } from '../../hooks';
import { ShareModal } from '../ShareModal/ShareModal';

import styles from './Share.scss';
import classnames from 'classnames';

interface ShareProps {
  modalHeading?: string;
  successType?: string;
  shareUrl?: string;
  messageOverrides?: MessageOverrides;
  buttonClassName?: string;
  trackingIdentifier?: string;
}

export const Share: FunctionComponent<ShareProps> = ({
  modalHeading,
  successType,
  shareUrl,
  messageOverrides,
  buttonClassName,
  trackingIdentifier,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [isOpen, setOpen] = useState(false);
  const shareUrls = useShareUrls(shareUrl, messageOverrides);
  const { isPageOwner, data: pageOwnerData } = usePageOwner();

  const shareModalHeading = () => {
    if (modalHeading) {
      return modalHeading;
    }

    if (isPageOwner) {
      return t('shareModal.heading.pageOwner');
    }

    return t('shareModal.heading', {
      pageOwner: pageOwnerData?.owner?.name,
    });
  };

  return (
    <>
      <Button
        className={classnames(
          'jg-btn',
          buttonClassName ? buttonClassName : styles.shareButton,
        )}
        onClick={() => setOpen(true)}
        type="button"
        trackingData={{
          action_name: 'click',
          subtype: 'share',
          event: 'click',
          event_value: 'share',
        }}
        data-track={trackingIdentifier}
      >
        {t('common.share')}
      </Button>

      {isOpen && shareUrls ? (
        <ShareModal
          heading={shareModalHeading()}
          description={t('shareModal.description')}
          onClose={() => setOpen(false)}
          shareItems={shareUrls}
        />
      ) : null}
    </>
  );
};
